export function arrayEquals(a, b) {
    return Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) =>
            val.id == b[index].id &&
            val.cls == b[index].cls &&
            val.parent == b[index].parent);
}

export function debounceAsync(fn, wait) {
    let timer = null;
    let pendingReject = null;

    return function (...args) {
        if (timer) {
            clearTimeout(timer);
            timer = null;

            if (pendingReject) {
                pendingReject(new Error("Debounced"));
                pendingReject = null;
            }
        }

        return new Promise((resolve, reject) => {
            pendingReject = reject;

            timer = setTimeout(async () => {
                timer = null;
                pendingReject = null;

                try {
                    const result = await fn.apply(this, args);
                    resolve(result);
                } catch (err) {
                    reject(err);
                }
            }, wait);
        });
    };
}
